<template>

  <el-container style="width: 100%; border: 1px solid #eee; background-color: #FFFFFF">
    <el-aside width="200px" style="background-color: rgb(238, 241, 246); height: calc(100vh - 160px);">
      <el-menu :default-openeds="[]" @select="scrollToPosition" active-text-color="#0000FF" style="text-align: left;overflow-x: hidden">
        <el-menu-item index="0">Home</el-menu-item>
        <el-menu-item index="1">Statistics</el-menu-item>
        <el-menu-item index="2">Search</el-menu-item>
        <el-submenu index="3">
          <template slot="title">Datasets</template>
          <el-menu-item index="3">"Overview" Tag</el-menu-item>
          <el-menu-item index="4">"Marker" Tag</el-menu-item>
          <el-menu-item index="5">"SVGs" Tag</el-menu-item>
          <el-menu-item index="6">
            <span class="my-span-help" title="Cell_Type_Annotation_Tag">
              "Cell Type Annotation" Tag
            </span>
          </el-menu-item>
          <el-menu-item index="7">
            <span class="my-span-help" title="Tumor_Malignancy_Estimation_Tag">
              "Tumor Malignancy Estimation" Tag
            </span>
          </el-menu-item>
          <el-menu-item index="8">
            <span class="my-span-help" title="Cancer_Functional_State_Score_Tag">
              "Cancer Functional States Evaluation" Tag
            </span>
          </el-menu-item>
          <el-menu-item index="9">
            <span class="my-span-help" title="Immune_component_characterization">
              "Immune component characterization" Tag
            </span>
          </el-menu-item>
          <el-menu-item index="10">
            <span class="my-span-help" title="Multi-datasets_exploration">
              Multi-datasets exploration
            </span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item index="11">Upload</el-menu-item>
        <el-menu-item index="12">Download</el-menu-item>
        <el-menu-item index="13">News</el-menu-item>

<!--        <el-submenu index="1">-->
<!--          <template slot="title"><i class="el-icon-message"></i>导航一</template>-->
<!--          <el-menu-item-group>-->
<!--            <template slot="title">分组一</template>-->
<!--            <el-menu-item index="1-1">选项1</el-menu-item>-->
<!--            <el-menu-item index="1-2">选项2</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--          <el-menu-item-group title="分组2">-->
<!--            <el-menu-item index="1-3">选项3</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--          <el-submenu index="1-4">-->
<!--            <template slot="title">选项4</template>-->
<!--            <el-menu-item index="1-4-1">选项4-1</el-menu-item>-->
<!--          </el-submenu>-->
<!--        </el-submenu>-->
<!--        <el-submenu index="2">-->
<!--          <template slot="title"><i class="el-icon-menu"></i>导航二</template>-->
<!--          <el-menu-item-group>-->
<!--            <template slot="title">分组一</template>-->
<!--            <el-menu-item index="2-1">选项1</el-menu-item>-->
<!--            <el-menu-item index="2-2">选项2</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--          <el-menu-item-group title="分组2">-->
<!--            <el-menu-item index="2-3">选项3</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--          <el-submenu index="2-4">-->
<!--            <template slot="title">选项4</template>-->
<!--            <el-menu-item index="2-4-1">选项4-1</el-menu-item>-->
<!--          </el-submenu>-->
<!--        </el-submenu>-->
<!--        <el-submenu index="3">-->
<!--          <template slot="title"><i class="el-icon-setting"></i>导航三</template>-->
<!--          <el-menu-item-group>-->
<!--            <template slot="title">分组一</template>-->
<!--            <el-menu-item index="3-1">选项1</el-menu-item>-->
<!--            <el-menu-item index="3-2">选项2</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--          <el-menu-item-group title="分组2">-->
<!--            <el-menu-item index="3-3">选项3</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--          <el-submenu index="3-4">-->
<!--            <template slot="title">选项4</template>-->
<!--            <el-menu-item index="3-4-1">选项4-1</el-menu-item>-->
<!--          </el-submenu>-->
<!--        </el-submenu>-->

      </el-menu>
    </el-aside>

    <el-container class="my-content">
      <el-main>
<!--        <div class="my-container">-->
<!--          <h2>Help</h2>-->
<!--          <div class="my-text" style="font-weight: bold;padding-bottom: 5px">-->
<!--            <p class="my-p" @click="scrollToPosition(1)">1. CancerSRT Overview</p>-->
<!--            <p class="my-p" @click="scrollToPosition(2)">2. CancerSRT data collection and processing</p>-->
<!--            <p class="my-p" @click="scrollToPosition(3)">3. Gene-level analysis</p>-->
<!--            <p class="my-p" @click="scrollToPosition(4)">4. Cell-level analysis</p>-->
<!--            <p class="my-p" @click="scrollToPosition(5)">5. Human cancer-specific analysis</p>-->
<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash;    1. CancerSRT Overview&ndash;&gt;-->
<!--        <div class="my-container" style="margin: 0;padding: 0;">-->
<!--          <h2 style="text-align: left">-->
<!--            <span style="margin-left: 20px">1. CancerSRT Overview</span>-->
<!--          </h2>-->
<!--          <p class="my-text">-->
<!--            CancerSRT provides an online platform that does not require registration and login,-->
<!--            allowing users to search, browse, upload, and download the datasets. Specifically,-->
<!--            with a user-friendly interface of CancerSRT, one can visualize and explore the datasets-->
<!--            at the <b>gene level</b> (spatial gene expression, marker gene detection, spatial variable genes identification),-->
<!--            <b>cell level</b> (spatial distribution of cells, cell-cell interaction, cell type annotation),-->
<!--            and <b>cancer-specific level</b> (cancer functional states and tumor malignancy estimation).-->
<!--            We anticipate CancerSRT may promote the exploration of human cancer architectures at multiple levels.-->
<!--          </p>-->
<!--          <div class="my-div-center" style="margin-bottom: 5px">-->
<!--            <img src="../../assets/help/part1_0313.png" alt="part1.png load error" width="700px"/>-->
<!--          </div>-->
<!--        </div>-->

<!--        &lt;!&ndash;    2. CancerSRT data collection and processing&ndash;&gt;-->
<!--        <div class="my-container" style="margin: 0;padding: 0;">-->
<!--          <h2 style="text-align: left">-->
<!--            <span style="margin-left: 20px">2. CancerSRT data collection and processing</span>-->
<!--          </h2>-->
<!--          <div class="my-text">-->
<!--            <p>-->
<!--              <b>Data collection:</b> We systematically retrieved the human spatial transcriptomics datasets-->
<!--              on Gene Expression Omnibus (GEO, https://www.ncbi.nlm.nih.gov/geo/), Zenodo (https://zenodo.org/),-->
<!--              SpatialResearch (https://www.spatialresearch.org/), 10x spatial gene expression demonstration datasets-->
<!--              (https://support.10xgenomics.com/spatial-gene-expression/datasets), and 10x spatial publication list-->
<!--              (https://www.10xgenomics.com/resources/publications), using the SRT-related keywords such as-->
<!--              ‘Spatial Transcriptomics’ or ‘spatial transcriptome’ or ‘SRT’, as well as the technology-related-->
<!--              keywords like ‘10x Visium’, ‘spatial transcriptomics’ and ‘LCM-seq’, and the tumor-related keywords-->
<!--              like ‘cancer’ or ‘tumor’ or ‘carcinoma’.-->
<!--            </p>-->
<!--            <p style="margin-bottom: 5px">-->
<!--              <b>Data processing:</b> All datasets were processed using a unified workflow,-->
<!--              including quality control, highly variable gene selection, dimension reduction, clustering,-->
<!--              marker genes/spatial variable genes detection, cell type annotation, etc. In the quality control (QC) step,-->
<!--              we filtered out low-quality cells/spots (with expression in fewer than 30 genes) and low-quality genes-->
<!--              (expressed in fewer than 3 cells/spots). After QC, we utilized SCTransform in Seurat to normalize the datasets.-->
<!--              Highly variable genes (HVGs) were identified using the “vst” method in Seurat with the default parameters.-->
<!--              Then, we employed principal component analysis (PCA) to extract the top n principal components (PCs)-->
<!--              and used them to calculate the shared nearest neighbors (SNNs), where n is determined by the data size.-->
<!--              Next, visualization was performed using t-distributed stochastic neighbor embedding (t-SNE)-->
<!--              and uniform manifold approximation and projection (UMAP). For datasets with known annotated spatial-->
<!--              domain or cell type labels, we used them directly. For other datasets, we conducted the Louvain clustering-->
<!--              algorithm with default parameters to identify clusters. All data processing was conducted-->
<!--              using Seurat V4.-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->

<!--        &lt;!&ndash;    3. Gene-level analysis&ndash;&gt;-->
<!--        <div class="my-container" style="margin: 0;padding: 0;">-->
<!--          <h2 style="text-align: left">-->
<!--            <span style="margin-left: 20px">3. Gene-level analysis</span>-->
<!--          </h2>-->
<!--          <div class="my-text">-->
<!--            <h3 class="my-p">3.1 Identifying spatially variable genes(SVGs)</h3>-->
<!--            <p>-->
<!--              SV genes were identified by SpatialDE and trendsceek. SpatialDE and trendsceek are two-->
<!--              bioinformatics analysis tools that can directly identify genes with spatially structured-->
<!--              expression patterns in tissues. SpatialDE was derived from Gaussian process regression from-->
<!--              geostatistics. Trendsceek was derived from marked point processes from geostatistics,-->
<!--              astronomy and materials physics.-->
<!--            </p>-->
<!--            <div class="my-border">-->
<!--              <h3>SpatialDE:</h3>-->
<!--              <p>-->
<!--                <b>Reference:</b> Svensson V, Teichmann SA, Stegle O. SpatialDE: identification of spatially variable-->
<!--                genes. Nat Methods. 2018 May;15(5):343-346.<br/>-->
<!--                <b>Source code: </b><a href="https://github.com/Teichlab/SpatialDE" target="_blank">https://github.com/Teichlab/SpatialDE</a>-->
<!--              </p>-->
<!--              <h3>trendsceek:</h3>-->
<!--              <p>-->
<!--                <b>Reference:</b> Edsgärd D, Johnsson P, Sandberg R. Identification of spatial expression trends in-->
<!--                single-cell gene expression data. Nat Methods. 2018 May;15(5):339-342.<br/>-->
<!--                <b>Source code: </b><a href="https://github.com/edsgard/trendsceek" target="_blank">https://github.com/edsgard/trendsceek</a>-->
<!--              </p>-->
<!--            </div>-->

<!--            <h3 class="my-p">3.2 Functional enrichment analysis of SVGs</h3>-->
<!--            <p>-->
<!--              We extracted SVGs gene lists and utilized the ClusterProfiler toolkit (version 3.12.0)to-->
<!--              enrichment analysis by Gene Ontology(GO) and Kyoto Encyclopedia of Genes and-->
<!--              Genomes(KEGG). Meanwhile, we draw scatter plots and pathway maps to visualize functional-->
<!--              and pathway enrichment. The ClusterProfiler package is from the Bioconductor (version 3.9).-->
<!--            </p>-->
<!--            <div class="my-border">-->
<!--              <p style="text-indent: 0">-->
<!--                <b>Parameters:</b>-->
<!--                <br/>-->
<!--                <b>GO:</b> ont='ALL',pAdjustMethod = 'BH',pvalueCutoff = 0.05,qvalueCutoff = 0.2,keyType =-->
<!--                'ENTREZID'<br/>-->
<!--                <b>KEGG:</b> pvalueCutoff = 0.05, pAdjustMethod = 'BH', minGSSize = 10,maxGSSize =-->
<!--                500,qvalueCutoff = 0.2,use_internal_data = FALSE<br/>-->
<!--                <b>Reference:</b> Yu G, Wang LG, Han Y, He QY. clusterProfiler: an R package for comparing-->
<!--                biological themes among gene clusters. OMICS. 2012 May;16(5):284-7.<br/>-->
<!--                <b>Source code: </b><a href="https://bioconductor.org/packages/release/bioc/html/clusterProfiler.html" target="_blank">https://bioconductor.org/packages/release/bioc/html/clusterProfiler.html</a>-->
<!--              </p>-->
<!--            </div>-->
<!--            <h3  class="my-p">3.3 Spatial gene expression profile visualization</h3>-->
<!--            <p style="margin-bottom: 5px">-->
<!--              Users can visualise the spatially variable genes detected by different methods on spatially-->
<!--              stained sections. In addition, the user can view the spatial expression profile of the marker-->
<!--              genes for each sample.-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->

<!--        &lt;!&ndash;    4. Cell-level analysis&ndash;&gt;-->
<!--        <div class="my-container" style="margin: 0;padding: 0;">-->
<!--          <h2 style="text-align: left">-->
<!--            <span style="margin-left: 20px">4. Cell-level analysis</span>-->
<!--          </h2>-->
<!--          <div class="my-text">-->
<!--            <h3 class="my-p">4.1 Identification of cell types</h3>-->
<!--            <p>-->
<!--              To systematically annotate each dataset in CancerSRT, we performed-->
<!--              SingleR (v1.4.1) and Robust Cell Type Decomposition (RCTD) simultaneously.-->
<!--            </p>-->
<!--            <div class="my-border">-->
<!--              <h3>SingleR:</h3>-->
<!--              <p>-->
<!--                <b>Reference:</b> Aran D, Looney A P, Liu L, et al. Reference-based analysis of lung single-cell-->
<!--                sequencing reveals a transitional profibrotic macrophage[J]. Nature immunology, 2019, 20(2): 163-172.<br/>-->
<!--                <b>Source code: </b><a href="https://github.com/Ann-Holmes/SingleR" target="_blank">https://github.com/Ann-Holmes/SingleR</a>-->
<!--              </p>-->
<!--              <h3>RCTD:</h3>-->
<!--              <p>-->
<!--                <b>Reference:</b> Cable, D. M., Murray, E., Zou, L. S., Goeva, A., Macosko, E. Z., Chen, F., & Irizarry,-->
<!--                R. A. (2021). Robust decomposition of cell type mixtures in spatial transcriptomics. Nature-->
<!--                Biotechnology, 1-10.<br/>-->
<!--                <b>Source code: </b><a href="https://github.com/dmcable/spacexr" target="_blank">https://github.com/dmcable/spacexr</a>-->
<!--              </p>-->
<!--            </div>-->

<!--            <h3 class="my-p">4.2 Analyzing of cell-cell communication</h3>-->
<!--            <p>-->
<!--              By combining an integrated approach of social network analysis, pattern recognition and-->
<!--              multiple learning methods, we use the CellChat software package to quantitatively describe-->
<!--              and compare inferred cell-cell communication networks using hierarchical or circle diagrams-->
<!--              to visualise each signalling pathway.-->
<!--            </p>-->
<!--            <div class="my-border">-->
<!--              <h3>CellChat:</h3>-->
<!--              <p style="margin-bottom: 5px">-->
<!--                <b>Reference:</b> Jin, S., Guerrero-Juarez, C.F., Zhang, L. et al. Inference and analysis of cell-cell-->
<!--                communication using CellChat. Nat Commun 12, 1088 (2021).<br/>-->
<!--                <b>Source code: </b><a href="https://github.com/sqjin/CellChat" target="_blank">https://github.com/sqjin/CellChat</a>-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        &lt;!&ndash;    5. Human cancer-specific analysis&ndash;&gt;-->
<!--        <div class="my-container" style="margin: 0;padding: 0;">-->
<!--          <h2 style="text-align: left">-->
<!--            <span style="margin-left: 20px">5. Human cancer-specific analysis</span>-->
<!--          </h2>-->
<!--          <div class="my-text">-->
<!--            <h3 class="my-p">5.1 Infering the chromosome copy number alterations(CNV)</h3>-->
<!--            <p>-->
<!--              Two representative algorithms InferCNV and Copykat are used to estimate CNVs in tumor SRT data.-->
<!--            </p>-->
<!--            <div class="my-border">-->
<!--              <h3>InferCNV(scCancer):</h3>-->
<!--              <p>-->
<!--                <b>Reference:</b> Guo, W., Wang, D., Wang, S., Shan, Y., Liu, C., & Gu, J. (2021). scCancer: a package-->
<!--                for automated processing of single-cell RNA-seq data in cancer. Briefings in bioinformatics,-->
<!--                22(3), bbaa127.<br/>-->
<!--                <b>Source code: </b><a href="https://github.com/wguo-research/scCancer" target="_blank">https://github.com/wguo-research/scCancer</a>-->
<!--              </p>-->
<!--              <h3>Copykat:</h3>-->
<!--              <p>-->
<!--                <b>Reference:</b> Gao, R., Bai, S., Henderson, Y. C., Lin, Y., Schalck, A., Yan, Y., ... & Navin, N. E. (2021).-->
<!--                Delineating copy number and clonal substructure in human tumors from single-cell-->
<!--                transcriptomes. Nature biotechnology, 39(5), 599-608.<br/>-->
<!--                <b>Source code: </b><a href="https://github.com/navinlabcode/copykat" target="_blank">https://github.com/navinlabcode/copykat</a>-->
<!--              </p>-->
<!--            </div>-->

<!--            <h3  class="my-p">5.2 Cancer functional states analysis</h3>-->
<!--            <p>-->
<!--              To characterize cancer samlpes cellular heterogeneity, we used 14 cancer functional states-->
<!--              and their gene signatures (including stemness, invasion, metastasis, proliferation, EMT,-->
<!--              angiogenesis, apoptosis, cell cycle, differentiation, DNA damage, DNA repair, hypoxia,-->
<!--              inflammation and quiescence) defined by CancerSEA to estimate variation scores over the-->
<!--              spots via gene set variation analysis (GSVA), which was widely used to analyze signatures on-->
<!--              various cancer types.-->
<!--            </p>-->
<!--            <div class="my-border">-->
<!--              <h3>CancerSEA:</h3>-->
<!--              <p>-->
<!--                <b>Reference:</b> Yuan, H., Yan, M., Zhang, G., Liu, W., Deng, C., Liao, G., ... & Li, X. (2019). CancerSEA:-->
<!--                a cancer single-cell state atlas. Nucleic acids research, 47(D1), D900-D908.<br/>-->
<!--                <b>Website: </b><a href="http://biocc.hrbmu.edu.cn/CancerSEA/" target="_blank">http://biocc.hrbmu.edu.cn/CancerSEA/</a>-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <div class="my-container" style="margin: 0;padding: 0;">
          <h2 style="text-align: left">
            <span style="margin-left: 20px">Home Page</span>
          </h2>
          <div class="my-div-center" style="margin-bottom: 5px">
<!--            <el-image-->
<!--                style="width: 70%"-->
<!--                :src="home_url_small"-->
<!--                :preview-src-list="home_url">-->
<!--            </el-image>-->
            <img src="../../assets/help/help_home2.png" alt="help_home.png load error" width="80%"/>
          </div>
        </div>

        <div class="my-container" style="margin: 0;padding: 0;">
          <h2 style="text-align: left">
            <span style="margin-left: 20px">Statistics Page</span>
          </h2>
          <div class="my-div-center" style="margin-bottom: 5px">
<!--            <el-image-->
<!--                style="width: 70%"-->
<!--                :src="statistics_url_small"-->
<!--                :preview-src-list="statistics_url">-->
<!--            </el-image>-->
            <img src="../../assets/help/help_statistics2.png" alt="help_statistics.png load error" width="80%"/>
          </div>
        </div>

        <div class="my-container" style="margin: 0;padding: 0;">
          <h2 style="text-align: left">
            <span style="margin-left: 20px">Search Page</span>
          </h2>
          <div class="my-div-center" style="margin-bottom: 5px">
<!--            <el-image-->
<!--                style="width: 70%"-->
<!--                :src="search_url_small"-->
<!--                :preview-src-list="search_url">-->
<!--            </el-image>-->
            <img src="../../assets/help/help_search2.png" alt="help_search.png load error" width="80%"/>
          </div>
        </div>

        <div class="my-container" style="margin: 0;padding: 0;">
          <h2 style="text-align: left">
            <span style="margin-left: 20px">Dataset Page -- "Overview" Tag</span>
          </h2>
          <div class="my-div-center" style="margin-bottom: 5px">
<!--            <el-image-->
<!--                style="width: 70%"-->
<!--                :src="dataset_overview_url_small"-->
<!--                :preview-src-list="dataset_overview_url">-->
<!--            </el-image>-->
            <img src="../../assets/help/help_dataset_overview2.png" alt="help_dataset_overview.png load error" width="80%"/>
          </div>
        </div>

        <div class="my-container" style="margin: 0;padding: 0;">
          <h2 style="text-align: left">
            <span style="margin-left: 20px">Dataset Page -- "Marker" Tag</span>
          </h2>
          <div class="my-div-center" style="margin-bottom: 5px">
<!--            <el-image-->
<!--                style="width: 70%"-->
<!--                :src="dataset_marker_url_small"-->
<!--                :preview-src-list="dataset_marker_url">-->
<!--            </el-image>-->
            <img src="../../assets/help/help_dataset_marker2.png" alt="help_dataset_marker.png load error" width="80%"/>
          </div>
        </div>

        <div class="my-container" style="margin: 0;padding: 0;">
          <h2 style="text-align: left">
            <span style="margin-left: 20px">Dataset Page -- "SVGs" Tag</span>
          </h2>
          <div class="my-div-center" style="margin-bottom: 5px">
<!--            <el-image-->
<!--                style="width: 70%"-->
<!--                :src="dataset_svg_url_small"-->
<!--                :preview-src-list="dataset_svg_url">-->
<!--            </el-image>-->
            <img src="../../assets/help/help_dataset_svg2.png" alt="help_dataset_svg.png load error" width="80%"/>
          </div>
        </div>

        <div class="my-container" style="margin: 0;padding: 0;">
          <h2 style="text-align: left">
            <span style="margin-left: 20px">Dataset Page -- "Cell Type Annotation" Tag</span>
          </h2>
          <div class="my-div-center" style="margin-bottom: 5px">
<!--            <el-image-->
<!--                style="width: 70%"-->
<!--                :src="dataset_celltype_url_small"-->
<!--                :preview-src-list="dataset_celltype_url">-->
<!--            </el-image>-->
            <img src="../../assets/help/help_dataset_celltype2.png" alt="help_dataset_celltype.png load error" width="80%"/>
          </div>
        </div>

        <div class="my-container" style="margin: 0;padding: 0;">
          <h2 style="text-align: left">
            <span style="margin-left: 20px">Dataset Page -- "Tumor Malignancy Estimation" Tag</span>
          </h2>
          <div class="my-div-center" style="margin-bottom: 5px">
<!--            <el-image-->
<!--                style="width: 70%"-->
<!--                :src="dataset_estimate_url_small"-->
<!--                :preview-src-list="dataset_estimate_url">-->
<!--            </el-image>-->
            <img src="../../assets/help/help_dataset_estimate2.png" alt="help_dataset_estimate.png load error" width="80%"/>
          </div>
        </div>

        <div class="my-container" style="margin: 0;padding: 0;">
          <h2 style="text-align: left">
            <span style="margin-left: 20px">Dataset Page -- "Cancer Functional States Evaluation" Tag</span>
          </h2>
          <div class="my-div-center" style="margin-bottom: 5px">
<!--            <el-image-->
<!--                style="width: 70%"-->
<!--                :src="dataset_state_url_small"-->
<!--                :preview-src-list="dataset_state_url">-->
<!--            </el-image>-->
            <img src="../../assets/help/help_dataset_state2.png" alt="help_dataset_state.png load error" width="80%"/>
          </div>
        </div>

        <div class="my-container" style="margin: 0;padding: 0;">
          <h2 style="text-align: left">
            <span style="margin-left: 20px">Dataset Page -- "Immune component characterization" Tag</span>
          </h2>
          <div class="my-div-center" style="margin-bottom: 5px">
            <!--            <el-image-->
            <!--                style="width: 70%"-->
            <!--                :src="dataset_state_url_small"-->
            <!--                :preview-src-list="dataset_state_url">-->
            <!--            </el-image>-->
            <img src="../../assets/help/help_dataset_immune2.png" alt="help_dataset_immune.png load error" width="80%"/>
          </div>
        </div>

        <div class="my-container" style="margin: 0;padding: 0;">
          <h2 style="text-align: left">
            <span style="margin-left: 20px">Dataset Page -- Multi-datasets exploration</span>
          </h2>
          <div class="my-div-center" style="margin-bottom: 5px">
            <!--            <el-image-->
            <!--                style="width: 70%"-->
            <!--                :src="download_url_small"-->
            <!--                :preview-src-list="download_url">-->
            <!--            </el-image>-->
            <img src="../../assets/help/help_compare2.png" alt="help_download.png load error" width="80%"/>
          </div>
        </div>

        <div class="my-container" style="margin: 0;padding: 0;">
          <h2 style="text-align: left">
            <span style="margin-left: 20px">Upload Page</span>
          </h2>
          <div class="my-div-center" style="margin-bottom: 5px">
<!--            <el-image-->
<!--                style="width: 70%"-->
<!--                :src="upload_url_small"-->
<!--                :preview-src-list="upload_url">-->
<!--            </el-image>-->
            <img src="../../assets/help/help_upload.png" alt="help_upload.png load error" width="80%"/>
          </div>
        </div>

        <div class="my-container" style="margin: 0;padding: 0;">
          <h2 style="text-align: left">
            <span style="margin-left: 20px">Download Page</span>
          </h2>
          <div class="my-div-center" style="margin-bottom: 5px">
<!--            <el-image-->
<!--                style="width: 70%"-->
<!--                :src="download_url_small"-->
<!--                :preview-src-list="download_url">-->
<!--            </el-image>-->
            <img src="../../assets/help/help_download2.png" alt="help_download.png load error" width="80%"/>
          </div>
        </div>

        <!--    6. News-->
        <div class="my-container" style="margin: 0;padding: 0;">
          <h2 style="text-align: left">
            <span style="margin-left: 20px">6. News</span>
          </h2>
          <div id="news-body">
<!--            <div class="title">News</div>-->
            <ul class="node-list">
              <li class="node">
                <div class="bullet">
                  <div class="bullet-dot"></div>
                </div>
                <div class="content mm-editor" ><span>2023.2.10</span></div>
                <div class="children"><ul class="node-list">
                  <li class="node">
                    <div class="bullet">
                      <div class="bullet-dot"></div>
                    </div>
                    <div class="content mm-editor" ><span>Completed the construction of CancerSRT version1, including a total of 30 datasets (192 sub-datasets) across 13 human cancers.</span></div>
                  </li>
                </ul></div>
              </li>
              <li class="node">
                <div class="bullet">
                  <div class="bullet-dot"></div>
                </div>
                <div class="content mm-editor" ><span>2023.3.12</span></div>
                <div class="children"><ul class="node-list">
                  <li class="node">
                    <div class="bullet">
                      <div class="bullet-dot"></div>
                    </div>
                    <div class="content mm-editor" ><span>Add new 10X Visium datasets about liver cancer from paper "Comprehensive analysis of spatial architecture in primary liver cancer".</span></div>
                  </li>
                </ul></div>
              </li>
              <li class="node">
                <div class="bullet">
                  <div class="bullet-dot"></div>
                </div>
                <div class="content mm-editor" ><span>2023.4.1</span></div>
                <div class="children"><ul class="node-list">
                  <li class="node">
                    <div class="bullet">
                      <div class="bullet-dot"></div>
                    </div>
                    <div class="content mm-editor" ><span>Completed the construction of CancerSRT version2, including a total of 31 datasets (213 sub-datasets) across 13 human cancers.</span></div>
                  </li>
                </ul></div>
              </li>
              <li class="node">
                <div class="bullet">
                  <div class="bullet-dot"></div>
                </div>
                <div class="content mm-editor" ><span>2023.4.20</span></div>
                <div class="children"><ul class="node-list">
                  <li class="node">
                    <div class="bullet">
                      <div class="bullet-dot"></div>
                    </div>
                    <div class="content mm-editor" ><span>Add new 10X Visium datasets about glioblastoma from paper "Spatial transcriptomics reveals niche-specific enrichment and vulnerabilities of radial glial stem-like cells in malignant gliomas".</span></div>
                  </li>
                  <li class="node">
                    <div class="bullet">
                      <div class="bullet-dot"></div>
                    </div>
                    <div class="content mm-editor" ><span>Add new 10X Visium datasets about glioblastoma from paper "Spatially resolved multi-omics deciphers bidirectional tumor-host interdependence in glioblastoma".</span></div>
                  </li>
                </ul></div>
              </li>
              <li class="node">
                <div class="bullet">
                  <div class="bullet-dot"></div>
                </div>
                <div class="content mm-editor" ><span>2023.7.1</span></div>
                <div class="children"><ul class="node-list">
                  <li class="node">
                    <div class="bullet">
                      <div class="bullet-dot"></div>
                    </div>
                    <div class="content mm-editor" ><span>Completed the construction of CancerSRT version3, including a total of 33 datasets (254 sub-datasets) across 13 human cancers.</span></div>
                  </li>
                </ul></div>
              </li>
              <li class="node">
                <div class="bullet">
                  <div class="bullet-dot"></div>
                </div>
                <div class="content mm-editor" ><span>2023.10.31</span></div>
                <div class="children"><ul class="node-list">
                  <li class="node">
                    <div class="bullet">
                      <div class="bullet-dot"></div>
                    </div>
                    <div class="content mm-editor" ><span>Completed the construction of CancerSRT version4, including a total of 39 datasets (310 sub-datasets) across 14 human cancers.</span></div>
                  </li>
                  <li class="node">
                    <div class="bullet">
                      <div class="bullet-dot"></div>
                    </div>
                    <div class="content mm-editor" ><span>The MERSCOPE datasets and the Stereo-seq datasets are upcoming.</span></div>
                  </li>
                </ul></div>
              </li>
              <li class="node">
                <div class="bullet">
                  <div class="bullet-dot"></div>
                </div>
                <div class="content mm-editor" ><span>2024.2.7</span></div>
                <div class="children"><ul class="node-list">
                  <li class="node">
                    <div class="bullet">
                      <div class="bullet-dot"></div>
                    </div>
                    <div class="content mm-editor" ><span>Completed the construction of CancerSRT version5, including a total of 45 datasets(346 sub-datasets) across 14 human cancers.</span></div>
                  </li>
                  <li class="node">
                    <div class="bullet">
                      <div class="bullet-dot"></div>
                    </div>
                    <div class="content mm-editor" ><span>The MERSCOPE datasets and the Stereo-seq datasets are upcoming.</span></div>
                  </li>
                </ul></div>
              </li>
              <li class="node">
                <div class="bullet">
                  <div class="bullet-dot"></div>
                </div>
                <div class="content mm-editor" ></div>
              </li>
            </ul>
          </div>
        </div>
      </el-main>


    </el-container>
  </el-container>



</template>

<script>
export default {
  name: "Help",
  data(){
    return{
      home_url_small: require('/src/assets/help/help_home_small.png'),
      home_url: [require('/src/assets/help/help_home.png')],
      statistics_url_small: require('/src/assets/help/help_statistics_small.png'),
      statistics_url: [require('/src/assets/help/help_statistics.png')],
      search_url_small: require('/src/assets/help/help_search_small.png'),
      search_url: [require('/src/assets/help/help_search.png')],
      dataset_overview_url_small: require('/src/assets/help/help_dataset_overview_small.png'),
      dataset_overview_url: [require('/src/assets/help/help_dataset_overview.png')],
      dataset_marker_url_small: require('/src/assets/help/help_dataset_marker_small.png'),
      dataset_marker_url: [require('/src/assets/help/help_dataset_marker.png')],
      dataset_svg_url_small: require('/src/assets/help/help_dataset_svg_small.png'),
      dataset_svg_url: [require('/src/assets/help/help_dataset_svg.png')],
      dataset_celltype_url_small: require('/src/assets/help/help_dataset_celltype_small.png'),
      dataset_celltype_url: [require('/src/assets/help/help_dataset_celltype.png')],
      dataset_estimate_url_small: require('/src/assets/help/help_dataset_estimate_small.png'),
      dataset_estimate_url: [require('/src/assets/help/help_dataset_estimate.png')],
      dataset_state_url_small: require('/src/assets/help/help_dataset_state_small.png'),
      dataset_state_url: [require('/src/assets/help/help_dataset_state.png')],
      upload_url_small: require('/src/assets/help/help_upload_small.png'),
      upload_url: [require('/src/assets/help/help_upload.png')],
      download_url_small: require('/src/assets/help/help_download_small.png'),
      download_url: [require('/src/assets/help/help_download.png')],
    }
  },
  methods:{
    scrollToPosition(index){
      document.getElementsByClassName('my-container')[index].scrollIntoView({
        behavior: "smooth",
        // behavior: auto; //定义动画过渡效果"auto"或 "smooth" 之一。默认为 "auto"。
        // block: start;  //定义垂直方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "start"。
        // inline:nearest//"start", "center", "end", 或 "nearest"之一。默认为 "nearest"。
      })
    },
    linkToPage(no, val){
      console.log(no,val)
      if (no === '1'){
        this.$router.push({
          path: '/Dataset/'+val+'/20210101'
        })
      }else {
        this.$router.push({
          path: '/'+val
        })
      }
    },
  }
}
</script>

<style scoped>

.my-text {
  text-indent: 2em;
  text-align: justify;
  word-spacing: 5px;
  line-height: 25px;
  font-size: 18px;
  margin:0 30px 0 30px;
  color: black;
}
.my-border {
  border: #696969 solid 1px;
  padding: 0 20px 0 20px;
  margin: 5px 0 5px 0;
}
.my-p:hover{
  text-decoration: underline;
  cursor: pointer;
}
.el-header {
  background-color: #B3C0D1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}
.my-content {
  height: calc(100vh - 160px);
}

.my-span-help{
  display:block;
  width:90%;
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  /*right: 0;*/
}

#news-body {
  margin: 50px 20px;
  padding: 0;
  color: #333;
  font-family: 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'PingFang SC',
  Helvetica, Arial, 'Microsoft YaHei', 微软雅黑, 黑体, Heiti, sans-serif,
  SimSun, 宋体, serif,
  'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
}

#news-body.narrow {
  max-width: 790px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
}

.title {
  min-height: 40px;
  padding-left: 10px;
  padding-bottom: 24px;
  margin-bottom: 20px;
  line-height: 40px;
  font-size: 26px;
  font-weight: 500;
  text-align: left;
  border-bottom: 1px solid #e5e6e8;
}
.mm-editor{
  text-align: left;
}

.node-list {
  margin: 0 0 0 28px;
  padding: 0;
  list-style: none;
}

.node {
  position: relative;
}

.node.drill-node > .content {
  margin-bottom: 15px;
  font-size: 20px;
  line-height: 28px;
}

.node.drill-node > .note {
  margin-bottom: 10px;
}

.content {
  min-height: 24px;
  padding-top: 2px;
  padding-bottom: 3px;
  line-height: 24px;
  font-size: 16px;
}


.note {
  position: relative;
  padding-bottom: 2px;
  line-height: 22px;
  font-size: 14px;
  color: #888;
  white-space: pre-wrap;
}

.content > *,
.note > * {
  padding-top: 2px;
  padding-bottom: 2px;
}

.note:empty {
  padding-bottom: 0;
}

.node.finished .content,
.node.finished .note {
  opacity: 0.5;
}

.node.finished > .content {
  text-decoration: line-through;
}

.heading1 > .content {
  min-height: 34px;
  line-height: 34px;
  font-size: 24px;
  font-weight: 500;
}

.heading2 > .content {
  min-height: 30px;
  line-height: 30px;
  font-size: 21px;
  font-weight: 500;
}

.heading3 > .content {
  min-height: 27px;
  line-height: 27px;
  font-size: 19px;
  font-weight: 500;
}

.mention {
  padding-left: 2px;
  padding-right: 2px;
  color: #5856d5;
  word-break: break-all;
  text-decoration: none;
}

.content-link {
  color: unset;
  opacity: 0.6;
  word-break: break-all;
}

.tag {
  text-decoration: underline;
  opacity: 0.6;
}

.bold {
  font-weight: bold;
}

.italic {
  font-style: italic;
}

.underline {
  text-decoration: underline;
}

.content .highlight-red,
.highlight-red > .content > * {
  background-color: #fbbfbc;
}

.content .highlight-yellow,
.highlight-yellow > .content > * {
  background-color: #f8e6ab;
}

.content .highlight-blue,
.highlight-blue > .content > * {
  background-color: #bacefd;
}

.content .highlight-cyan,
.highlight-cyan > .content > * {
  background-color: #a9efe6;
}

.content .highlight-pink,
.highlight-pink > .content > * {
  background-color: #fdddef;
}

.content .highlight-olive,
.highlight-olive > .content > * {
  background-color: #bbbfc4;
}

.content .highlight-grey,
.highlight-grey > .content > * {
  background-color: #bbbfc4;
}

.text-color-red {
  color: #dc2d1e;
}

.text-color-yellow {
  color: #ffaf38;
}

.text-color-green {
  color: #75c940;
}

.text-color-blue {
  color: #3da8f5;
}

.text-color-purple {
  color: #797ec9;
}

.bullet {
  position: absolute;
  left: -25px;
  top: 5px;
  width: 18px;
  height: 18px;
  border-radius: 9px;
}

.node.collapsed > .bullet {
  background-color: #dee0e3;
}

.heading1 > .bullet {
  top: 10px;
}

.heading2 > .bullet {
  top: 8px;
}

.heading3 > .bullet {
  top: 6px;
}

.bullet-dot {
  position: absolute;
  left: 6px;
  top: 6px;
  width: 6px;
  height: 6px;
  background-color: rgb(100, 106, 115);
  border-radius: 3px;
}

.image-list {
  position: relative;
  margin: 0;
  padding: 0;
  list-style: none;
}

.image-item {
  padding-top: 2px;
  padding-bottom: 8px;
}

.image {
  display: block;
  max-width: 100%;
}

.children {
  position: relative;
}

.note::before,
.image-list::before,
.children::before {
  content: "";
  position: absolute;
  top: 0;
  left: -17px;
  width: 1px;
  height: 100%;
  background-color: #dee0e3;
}

.node.drill-node > .note::before,
.node.drill-node > .image-list::before,
.node.drill-node > .children::before,
body.noline .note::before,
body.noline .image-list::before,
body.noline .children::before {
  display: none;
}

.node.drill-node > .note,
.node.drill-node > .content,
.node.drill-node > .image-list,
.node.drill-node > .children {
  margin-left: 10px;
}

body.noline .node-list {
  margin-right: 20px;
}

.publish {
  margin-top: 20px;
  text-align: center;
  font-size: 13px;
  color: #666;
}

.publish-link {
  color: #4694FF;
}

.node .mention.mm-iconfont::before {
  content: '\e601';
}

.node .mention.mm-iconfont {
  color: #5856d5;
}
</style>
